import styled from 'styled-components';
import {
  TextField,
} from '@mui/material';

import { fontFamily } from '../../../../../../styles/text';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 30px 60px;
`;

const Title = styled.div`
  font-family: ${fontFamily.sansSerif};
  flex: 1;
  font-size: 24px;
  white-space: nowrap;
  text-align: center;
  margin: 20px;
`;

const StyledTextField = styled(TextField)`
  margin: 20px 0 10px 0;
  width: 100%;
`;

export {
  Container,
  Title,
  StyledTextField,
};
